// Global ScrollSmoother control functions
let scrollHistory = []; // Array to store {time, amount} of scroll events
let lastScrollPosition = window.scrollY || 0;
const SCROLL_THRESHOLD = 50; // Minimum scroll amount to trigger pause (in pixels)
const TIME_WINDOW = 1000; // Time window in milliseconds to accumulate scroll amount

// Track scroll amount with timestamps
const trackScroll = () => {
    const currentScrollPosition = window.scrollY || 0;
    const scrollDelta = Math.abs(currentScrollPosition - lastScrollPosition);
    const currentTime = Date.now();
    
    if (scrollDelta > 0) {
        // Add scroll event to history
        scrollHistory.push({
            time: currentTime,
            amount: scrollDelta
        });
        
        // Remove scroll events older than TIME_WINDOW
        scrollHistory = scrollHistory.filter(event => currentTime - event.time <= TIME_WINDOW);
    }
    
    lastScrollPosition = currentScrollPosition;
};

window.addEventListener('scroll', trackScroll, { passive: true });
window.addEventListener('wheel', trackScroll, { passive: true });

window.pauseScrollSmoother = function() {
    // Calculate total scroll amount within the time window
    const currentTime = Date.now();
    const recentScrollEvents = scrollHistory.filter(event => currentTime - event.time <= TIME_WINDOW);
    const totalScrollAmount = recentScrollEvents.reduce((sum, event) => sum + event.amount, 0);
    
    // Only pause if scroll amount exceeds threshold within the time window
    if (totalScrollAmount >= SCROLL_THRESHOLD) {
        if (typeof ScrollSmoother !== 'undefined') {
            try {
                const smoother = ScrollSmoother.get();
                if (smoother && typeof smoother.paused === 'function' && !smoother.paused()) {
                    smoother.paused(true);
                }
            } catch (e) {
                // ScrollSmoother might not be fully initialized yet
                console.warn('ScrollSmoother not ready for pause:', e);
            }
        }
        // Clear scroll history after pausing
        scrollHistory = [];
    }
};

window.resumeScrollSmoother = function() {
    if (typeof ScrollSmoother !== 'undefined') {
        try {
            const smoother = ScrollSmoother.get();
            if (smoother && typeof smoother.paused === 'function' && smoother.paused()) {
                smoother.paused(false);
            }
        } catch (e) {
            // ScrollSmoother might not be fully initialized yet
            console.warn('ScrollSmoother not ready for resume:', e);
        }
    }
};

const all_slide = document.querySelectorAll(".swiper-slide");

gsap.set(".heading-step-captions > *", { opacity: 0, clipPath: "inset(100% 0% 0% 0%)" });
gsap.set(document.body, { backgroundColor: "#fff" });

all_slide.forEach((slide, slideIndex) => {
    const captions = slide.querySelectorAll(".heading-step-captions > *");
    
    if (captions.length > 0) {
        const tl = gsap.timeline({ repeat: -1 });
        
        tl.to(captions, { 
            keyframes: [
                { clipPath: "inset(0% 0% 0% 0%)", opacity: 1, duration: 0.8, ease: "power2.out" },
                { clipPath: "inset(0% 0% 0% 0%)", opacity: 1, duration: 0.8, ease: "power2.in" },
                { clipPath: "inset(0% 0% 0% 0%)", opacity: 1, duration: 0.8, ease: "power2.in" },
                { clipPath: "inset(100% 0% 0% 0%)", opacity: 0, duration: 0.8, ease: "power2.in" },
                { clipPath: "inset(0% 0% 0% 0%)", opacity: 0, duration: 0.8, ease: "power2.in" }
            ],
            stagger: 3.8
        });
    }
});

// Collection List 01 Animation
const collectionLists = document.querySelectorAll(".collection-list");

collectionLists.forEach((collectionList) => {
    // Check if animation is enabled via data attribute
    const enableAnimation = collectionList.getAttribute("data-enable-animation");
    // Return early if animation is disabled (attribute is "false" or not "true")
    if (enableAnimation !== "true") {
        return;
    }
    
    const items = collectionList.querySelectorAll(".collection-list__item_index");
    if (!items.length) return;
    
    const captions = collectionList.querySelectorAll(".card-collection-caption-top");
    const captionBefores = collectionList.querySelectorAll(".card-collection-caption-bottom-line");
    const captionHeadings = collectionList.querySelectorAll(".card-collection-caption-bottom .heading-block");
    const cardCaptions = collectionList.querySelectorAll(".card-collection-caption");
    
    gsap.set(items, { clipPath: "inset(100% 0% 0% 0%)" });
    gsap.set(captions, { y: "150%" });
    gsap.set(captionBefores, { opacity: 0, clipPath: "inset(0% 0% 100% 0%)" });
    gsap.set(captionHeadings, { opacity: 0 });
    gsap.set(cardCaptions, { y: 0 });
    
    const tl1 = gsap.timeline({
        scrollTrigger: {
            trigger: collectionList,
            start: "top center+=10%",
            end: "bottom top",
            toggleActions: "play none none reverse",
            // markers: false
        }
    });

    gsap.timeline({
        scrollTrigger: {
            trigger: collectionList,
            start: "center center",
            end: "bottom center",
            toggleActions: "play none none reverse",
            markers: false
        }
    });
    
    tl1.to(items, { clipPath: "inset(0% 0% 0% 0%)", duration: 0.8, ease: "power2.inOut", stagger: -0.15 })
        .to(captions, { y: 0, duration: 0.8, ease: "power2.inOut", stagger: -0.15 }, "-=0.6")
        .to([captionBefores, captionHeadings], { opacity: 1, clipPath: "inset(0% 0% 0% 0%)", duration: 0.6, ease: "power2.inOut" }, "-=0.3");
    
    gsap.timeline({
        scrollTrigger: {
            trigger: collectionList,
            start: "bottom center",
            end: "bottom top",
            toggleActions: "play none none reverse"
        }
    }).to(cardCaptions, { y: "-40%", opacity: 0, duration: 1, ease: "power2.inOut" });
});


// Media Banner with Text Index Scroll Animation
gsap.matchMedia().add("(min-width: 992px)", () => {
    const mediaBannerIndex = document.querySelector(".media_banner_with_text_index");
    if (!mediaBannerIndex) return;

    const mediaBannerWrapper = mediaBannerIndex.querySelector(".media-banner__wrapper");
    if (!mediaBannerWrapper) return;

    // Cache DOM elements
    const textElements = mediaBannerIndex.querySelectorAll(".heading-block *, .text-block *");
    const allMediaBanners = mediaBannerIndex.querySelectorAll(".media_banner_with_text");
    const allMediaIndexContent = mediaBannerIndex.querySelectorAll(".media_index_content");
    const allTextBlocks = mediaBannerIndex.querySelectorAll(".media_index_content .text-block p");
    const slideCount = allMediaBanners.length;
    
    if (slideCount === 0) return;

    // Cache play buttons for all slides upfront
    const playButtons = Array.from(allMediaBanners).map((banner, index) => ({
        button: banner.querySelector(".play__button"),
        index: index
    })).filter(item => item.button);

    // Set initial states
    gsap.set(mediaBannerWrapper, { x: "100%" });
    gsap.set(allMediaBanners, { clipPath: "inset(100% 0 0 0)" });
    gsap.set(allMediaIndexContent, { clipPath: "inset(0 0 0 100%)" });
    gsap.set(allTextBlocks, { opacity: 0 });
    gsap.set(allMediaBanners[0], { clipPath: "inset(0% 0 0 0)" });

    // ============================================
    // SLIDE-IN TIMELINE (Initial Entry Animation)
    // ============================================
    const slideInTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: mediaBannerIndex,
            start: "top center",
            end: "center center",
            scrub: 1,
            markers: false
        }
    });

        const firstPlayButton = playButtons.find(pb => pb.index === 0)?.button;
        
        slideInTimeline
        // Slide wrapper from right to left
        .to(mediaBannerWrapper, {
            x: "0%",
            duration: 2.5,
            ease: "power2.inOut",
            onComplete: () => {
                if (firstPlayButton) {
                    console.log("Auto-clicking first play button after right-to-left slide");
                    setTimeout(() => firstPlayButton.click(), 200);
                }
            }
        })
        // Change text color simultaneously
        .to(textElements, {
            color: "var(--media-banner-text-color)",
            duration: 2.5,
            ease: "power2.inOut"
        }, 0); // Start at same time as wrapper animation

    // ============================================
    // MAIN ANIMATION TIMELINE (Slide Transitions)
    // ============================================
    // Setup play button handlers for all slides
    playButtons.forEach(({ button, index }) => {
        button.addEventListener('click', () => {
            console.log(`Play button clicked for slide ${index + 1}!`);
        });
    });

    // Store timelines and states for each slide to enable reverse
    const slideTimelines = {};
    const slideStates = {};
    const contentTimelines = {};
    const contentStates = {};

    // Animation constants
    const ANIMATION_DURATIONS = {
        contentForward: 1,
        contentReverse: 0.5,
        textForward: 0.75,
        textReverse: 0.375,
        staggerForward: 0.1,
        staggerReverse: 0.05
    };

    // ============================================
    // HELPER FUNCTIONS
    // ============================================
    
    // Get slide elements by index
    const getSlideElements = (slideIndex) => ({
        content: allMediaIndexContent[slideIndex],
        textBlocks: allMediaIndexContent[slideIndex]?.querySelectorAll(".text-block p"),
        playButton: playButtons.find(pb => pb.index === slideIndex)?.button
    });

    // Toggle play button state
    const togglePlayButton = (playButton, enabled) => {
        if (!playButton) return;
        playButton.style.pointerEvents = enabled ? 'auto' : 'none';
        playButton.style.cursor = enabled ? 'pointer' : 'default';
    };

    // Create content animation timeline (forward or reverse)
    const createContentTimeline = (content, textBlocks, playButton, slideIndex, reverse = false) => {
        const timeline = gsap.timeline();
        const { contentForward, contentReverse, textForward, textReverse, staggerForward, staggerReverse } = ANIMATION_DURATIONS;
        
        timeline
            .to(content, {
                clipPath: reverse ? "inset(0 0 0 100%)" : "inset(0 0 0 0%)",
                duration: reverse ? contentReverse : contentForward,
                ease: "power2.inOut"
            })
            .to(textBlocks, {
                opacity: reverse ? 0 : 1,
                duration: reverse ? textReverse : textForward,
                ease: "power2.inOut",
                stagger: reverse ? staggerReverse : staggerForward
            }, reverse ? "-=0.25" : "-=0.5")
            .call(() => {
                togglePlayButton(playButton, !reverse);
                if (!reverse) {
                    console.log(`Play button for slide ${slideIndex + 1} is now clickable`);
                }
            }, null, reverse ? "-=0.05" : "-=0.1");
        
        return timeline;
    };

    // ============================================
    // ANIMATION FUNCTIONS (Triggered at specific points)
    // ============================================
    
    // First slide animation function
    const animateFirstSlide = (reverse = false) => {
        const slideIndex = 0;
        const currentState = slideStates[slideIndex];
        
        if (currentState === !reverse) return;
        if (reverse && !slideTimelines[slideIndex]) return;
        
        const { content, textBlocks, playButton } = getSlideElements(slideIndex);
        if (!content) return;
        
        const timeline = createContentTimeline(content, textBlocks, playButton, slideIndex + 1, reverse);
        slideTimelines[slideIndex] = timeline;
        slideStates[slideIndex] = !reverse;
    };

    // Content animation function (for slides 2+)
    const animateSlideContent = (slideIndex, reverse = false) => {
        const currentState = contentStates[slideIndex];
        
        if (currentState === !reverse) return;
        if (reverse && !contentTimelines[slideIndex]) return;
        
        const { content, textBlocks, playButton } = getSlideElements(slideIndex);
        if (!content) return;
        
        const timeline = createContentTimeline(content, textBlocks, playButton, slideIndex + 1, reverse);
        contentTimelines[slideIndex] = timeline;
        contentStates[slideIndex] = !reverse;
    };

    // ============================================
    // SCRUBBED BANNER TIMELINE FOR SLIDES 2+
    // ============================================
    // Animation constants
    const FIRST_SLIDE_DELAY = 0.05;
    const BANNER_COMPLETE_RATIO = 0.6;
    const CONTENT_DELAY = 0.03;
    const CONTENT_END_BUFFER = 0.1;
    const LAST_SLIDE_END = 0.99;
    const EXTRA_BLANK_SCROLL_DURATION = 1.5; // Extra blank scroll duration in seconds (reduced)
    
    let allAnimationsComplete = false;
    let previousProgress = 0;
    const bannerCompletePoints = {};
    
    // Create scrubbed timeline for banners (slides 2+)
    let bannerTimeline = null;
    if (slideCount > 1) {
        // Calculate total timeline duration including extra blank scroll
        const bannerDurationPerSlide = 2;
        const totalBannerDuration = (slideCount - 1) * bannerDurationPerSlide;
        const totalTimelineDuration = totalBannerDuration + EXTRA_BLANK_SCROLL_DURATION;
        // Calculate progress point where animations complete (before blank scroll starts)
        const ANIMATION_COMPLETE_PROGRESS = totalBannerDuration / totalTimelineDuration;
        
        // Pre-calculate slide trigger points scaled to account for blank scroll
        const slideProgress = ANIMATION_COMPLETE_PROGRESS / slideCount;
        const slideSpace = slideProgress;
        const slideTriggerPoints = Array.from({ length: slideCount }, (_, i) => ({
            index: i,
            start: (i / slideCount) * ANIMATION_COMPLETE_PROGRESS,
            end: ((i + 1) / slideCount) * ANIMATION_COMPLETE_PROGRESS,
            isLast: i === slideCount - 1
        }));
    
    // Helper function to handle first slide
    const handleFirstSlide = (progress, scrollDirection, previousProgress) => {
        const slide = slideTriggerPoints[0];
        const firstSlideDelay = FIRST_SLIDE_DELAY * ANIMATION_COMPLETE_PROGRESS;
        const firstSlideEndPoint = slideProgress * 1.5;
        const secondSlideStart = slideTriggerPoints[1]?.start || ANIMATION_COMPLETE_PROGRESS;
        
        if (scrollDirection === 'forward') {
            if (progress >= firstSlideDelay && progress < secondSlideStart && progress < firstSlideEndPoint) {
                animateFirstSlide(false);
            }
        } else if (progress < secondSlideStart && previousProgress >= firstSlideDelay && progress < firstSlideDelay) {
            animateFirstSlide(true);
        }
    };
    
    // Helper function to handle slides 2+
    const handleSlide = (slide, progress, scrollDirection, previousProgress, animationCompleteProgress = ANIMATION_COMPLETE_PROGRESS) => {
        const { index, start, end, isLast } = slide;
        const bannerCompletePoint = start + (slideSpace * BANNER_COMPLETE_RATIO);
        // Use absolute delay values, but ensure they don't exceed animation range
        const contentTriggerPoint = Math.min(bannerCompletePoint + CONTENT_DELAY, animationCompleteProgress);
        const contentEndPoint = isLast 
            ? animationCompleteProgress 
            : Math.min(Math.max(contentTriggerPoint + 0.05, end - CONTENT_END_BUFFER), animationCompleteProgress);
        
        if (scrollDirection === 'forward') {
            if (progress >= contentTriggerPoint && progress <= contentEndPoint && !bannerCompletePoints[index]) {
                bannerCompletePoints[index] = true;
                const playButton = playButtons.find(pb => pb.index === index)?.button;
                if (playButton) {
                    console.log(`Auto-clicking play button for slide ${index + 1} at progress ${progress.toFixed(2)}`);
                    setTimeout(() => playButton.click(), 200);
                }
                animateSlideContent(index, false);
            }
        } else {
            if ((previousProgress >= contentTriggerPoint && progress < contentTriggerPoint) ||
                (previousProgress >= start && progress < start)) {
                bannerCompletePoints[index] = false;
                animateSlideContent(index, true);
            }
        }
    };
        
        bannerTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: mediaBannerIndex,
                start: "center center",
                end: `center+=${250 + (EXTRA_BLANK_SCROLL_DURATION * 50)}% center`, // Adjusted for reduced blank scroll
                scrub: 1,
                pin: true,
                pinSpacing: true,
                anticipatePin: 1,
                markers: false,
                onUpdate: (self) => {
                    const progress = self.progress;
                    const scrollDirection = progress > previousProgress ? 'forward' : 'backward';
                    
                    // Handle first slide
                    handleFirstSlide(progress, scrollDirection, previousProgress);
                    
                    // Handle slides 2+
                    for (let i = 1; i < slideCount; i++) {
                        handleSlide(slideTriggerPoints[i], progress, scrollDirection, previousProgress, ANIMATION_COMPLETE_PROGRESS);
                    }
                    
                    // Trigger final fake scroll when animations complete (before blank scroll starts)
                    if (progress >= ANIMATION_COMPLETE_PROGRESS && !allAnimationsComplete && scrollDirection === 'forward') {
                        allAnimationsComplete = true;
                        console.log("All slide animations completed, entering blank scroll space");
                    } else if (progress < ANIMATION_COMPLETE_PROGRESS && scrollDirection === 'backward') {
                        allAnimationsComplete = false;
                    }
                    
                    previousProgress = progress;
                },
                onLeaveBack: () => {
                    // Reverse all content when leaving the section
                    Object.keys(contentTimelines).forEach(index => {
                        if (contentStates[index]) {
                            animateSlideContent(parseInt(index), true);
                        }
                    });
                    if (slideStates[0]) {
                        animateFirstSlide(true);
                    }
                    Object.keys(bannerCompletePoints).forEach(index => {
                        bannerCompletePoints[index] = false;
                    });
                    allAnimationsComplete = false;
                }
            }
        });

        // Add banner animations for slides 2+ to scrubbed timeline
        slideTriggerPoints.slice(1).forEach((slide) => {
            const banner = allMediaBanners[slide.index];
            if (!banner) return;
            
            // Convert progress value to timeline time position
            // slide.start is progress (0 to ANIMATION_COMPLETE_PROGRESS), convert to time
            const bannerStartPosition = (slide.start / ANIMATION_COMPLETE_PROGRESS) * totalBannerDuration;
            
            bannerTimeline.to(banner, {
                clipPath: "inset(0% 0 0 0)",
                duration: bannerDurationPerSlide,
                ease: "power2.inOut"
            }, bannerStartPosition);
        });
        
        // Add extra blank scroll space at the end of timeline
        // This creates scrollable space after all animations complete
        bannerTimeline.to({}, {
            duration: EXTRA_BLANK_SCROLL_DURATION,
            ease: "none"
        }, totalBannerDuration);
    }
});
// Mobile Video Trigger Script
gsap.matchMedia().add("(max-width: 991px)", () => {
    console.log("Mobile media query activated");
    
    const triggeredVideos = new Set();
    let scrollTimeout;
    
    // Cache selectors
    const selectors = [
        ".media_banner_with_text_index .media_banner_with_text",
        ".media_banner_with_text"
    ];
    
    // Get media banners with fallback selectors
    const getMediaBanners = () => {
        for (const selector of selectors) {
            const banners = document.querySelectorAll(selector);
            if (banners.length > 0) return banners;
        }
        return [];
    };
    
    // Check if element is in viewport
    const isInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        return rect.top < windowHeight * 0.8 && rect.bottom > windowHeight * 0.2;
    };
    
    // Trigger video play
    const triggerVideoPlay = (banner, index) => {
        const playButton = banner.querySelector('.play__button');
        if (!playButton || triggeredVideos.has(index)) return;
        
        console.log(`Mobile: Banner ${index + 1} is in viewport, clicking play button`);
        triggeredVideos.add(index);
        
        // Show and click play button
        Object.assign(playButton.style, {
            opacity: '1',
            visibility: 'visible',
            pointerEvents: 'auto'
        });
        
        setTimeout(() => {
            console.log(`Mobile: Clicking play button for banner ${index + 1}`);
            playButton.click();
        }, 300);
    };
    
    // Check all media banners
    const checkMediaBanners = () => {
        const banners = getMediaBanners();
        
        // Stop checking if all videos have been triggered
        if (triggeredVideos.size >= banners.length) {
            return;
        }
        
        console.log(`Mobile: Checking ${banners.length} media banners`);
        
        banners.forEach((banner, index) => {
            if (isInViewport(banner)) {
                triggerVideoPlay(banner, index);
            }
        });
    };
    
    // Debounced scroll handler
    const handleScroll = () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(checkMediaBanners, 100);
    };
    
    // Initialize
    const init = () => {
        console.log('Mobile video trigger script initialized');
        checkMediaBanners();
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', () => setTimeout(checkMediaBanners, 200));
    };
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
});

// Featured Collection Products Animation
document.querySelectorAll(".featured-collection-products").forEach((section) => {
    gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: "top bottom-=10%",
            end: "top bottom-=10%",
            toggleActions: "play none none reverse"
        }
    }).fromTo(section, {
        y: "10%",
    }, {
        y: 0,
        duration: 1,
        ease: "power2.inout"
    });
});
// Content Animation Functions (Reusable)
function getContentElements(section) {
    return {
        heading: section.querySelector(".heading-block"),
        text: section.querySelector(".text-block"),
        listItems: section.querySelectorAll(".text-block li"),
        buttons: section.querySelectorAll(".media_index_buttons .btn"),
        cta: section.querySelector(".cta-btn")
    };
}

function hideAllContent(elements) {
    Object.values(elements).forEach(el => {
        if (el) {
            // Check if it's a NodeList or HTMLCollection (has length and forEach)
            if (el.length !== undefined && typeof el.forEach === 'function') {
                el.forEach(item => {
                    if (item && item.classList) {
                        item.classList.add('gsap-hidden');
                    }
                });
            } 
            // Check if it's a single DOM element
            else if (el.classList) {
                el.classList.add('gsap-hidden');
            }
        }
    });
}

function showContent(elements) {
    gsap.set(".index_video_banner_content", { height: "auto" });
    if (elements.heading) gsap.killTweensOf(elements.heading);
    if (elements.text) gsap.killTweensOf(elements.text);
    elements.listItems.forEach(item => gsap.killTweensOf(item));
    elements.buttons.forEach(btn => gsap.killTweensOf(btn));
    if (elements.cta) gsap.killTweensOf(elements.cta);
    
    const animProps = { opacity: 1, y: 0, duration: 1.0, ease: "power2.out" };
    
    if (elements.heading) {
        elements.heading.classList.remove('gsap-hidden');
        gsap.fromTo(elements.heading, { opacity: 0, y: 50 }, animProps);
    }
    
    if (elements.text) {
        elements.text.classList.remove('gsap-hidden');
        gsap.fromTo(elements.text, { opacity: 0, y: 50 }, { ...animProps, delay: 0.2 });
    }
    
    elements.listItems.forEach((item, i) => {
        item.classList.remove('gsap-hidden');
        gsap.fromTo(item, { opacity: 0, y: 30 }, { ...animProps, delay: 0.4 + (i * 0.1) });
    });
    
    elements.buttons.forEach((btn, i) => {
        btn.classList.remove('gsap-hidden');
        gsap.fromTo(btn, { opacity: 0, y: 50 }, { ...animProps, delay: 0.8 + (i * 0.15) });
    });
    
    if (elements.cta) {
        elements.cta.classList.remove('gsap-hidden');
        gsap.fromTo(elements.cta, { opacity: 0, y: 50 }, { ...animProps, delay: 1.2 });
    }
}

function hideContent(elements) {
    // Kill any ongoing animations first to prevent conflicts
    if (elements.heading) gsap.killTweensOf(elements.heading);
    if (elements.text) gsap.killTweensOf(elements.text);
    elements.listItems.forEach(item => gsap.killTweensOf(item));
    elements.buttons.forEach(btn => gsap.killTweensOf(btn));
    if (elements.cta) gsap.killTweensOf(elements.cta);
    
    const hideProps = { opacity: 0, y: 50, duration: 0.2, ease: "power2.in" };
    
    // Create a timeline for synchronized hiding in reverse order
    // Show order: heading → text → listItems → buttons → cta
    // Hide order: cta → buttons → listItems → text → heading (reverse)
    const hideTimeline = gsap.timeline({
        onComplete: () => {
            // Ensure all elements have hidden class after animation
            if (elements.cta) elements.cta.classList.add('gsap-hidden');
            elements.buttons.forEach(btn => btn.classList.add('gsap-hidden'));
            elements.listItems.forEach(item => item.classList.add('gsap-hidden'));
            if (elements.text) elements.text.classList.add('gsap-hidden');
            if (elements.heading) elements.heading.classList.add('gsap-hidden');
        }
    });
    
    // Hide CTA first (appeared last)
    if (elements.cta) {
        hideTimeline.to(elements.cta, hideProps, 0);
    }
    
    // Hide buttons (reverse order - last button first)
    const buttonsArray = Array.from(elements.buttons);
    buttonsArray.reverse().forEach((btn, i) => {
        hideTimeline.to(btn, hideProps, 0.05 + (i * 0.05));
    });
    
    // Hide list items (reverse order - last item first)
    const listItemsArray = Array.from(elements.listItems);
    const buttonsEnd = 0.05 + (buttonsArray.length * 0.05);
    listItemsArray.reverse().forEach((item, i) => {
        hideTimeline.to(item, { 
            opacity: 0, 
            y: 30, 
            duration: 0.2, 
            ease: "power2.in"
        }, buttonsEnd + (i * 0.03));
    });
    
    // Hide text (appeared second)
    const listItemsEnd = buttonsEnd + (listItemsArray.length * 0.03);
    if (elements.text) {
        hideTimeline.to(elements.text, hideProps, listItemsEnd + 0.05);
    }
    
    // Hide heading last (appeared first)
    const textEnd = listItemsEnd + 0.05 + (elements.text ? 0.05 : 0);
    if (elements.heading) {
        hideTimeline.to(elements.heading, hideProps, textEnd + 0.05);
    }
    
    return hideTimeline;
}

// Desktop Animation (with shape animation)
gsap.matchMedia().add("(min-width: 992px)", () => {
    document.querySelectorAll(".video_banner_with_text").forEach((section) => {
        const textWrapper = section.querySelector(".index_video_text_wrapper");
        const elements = getContentElements(section);
        
        // Hide all content initially
        hideAllContent(elements);
        
        let contentTriggered = false;

        // Main animation timeline with structure: 60% shape, 20% content, 20% blank
        gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top top",
                end: "bottom+=150% top",
                pin: true,
                pinSpacing: true,
                scrub: 1,
                // markers: false,
                onUpdate: (self) => {
                    const progress = self.progress;
                    
                    // Content triggers directly at 60% (not scrubbed)
                    if (progress >= 0.6 && !contentTriggered) {
                        contentTriggered = true;
                        showContent(elements);
                    } else if (progress < 0.6 && contentTriggered) {
                        contentTriggered = false;
                        hideContent(elements);
                    }
                },
                onLeave: () => {
                    gsap.set(".collections-list-2-container", { x: "100%", y: "100%", opacity: 0 });
                }
            }
        })
        // 0% to 60%: Shape animation (scrubbed)
        .fromTo(textWrapper, {
            width: "339px",
            height: "180px",
            borderRadius: "416px"
        }, {
            width: "100%",
            height: "100%",
            borderRadius: "0px",
            duration: 0.6, // 60% of total timeline
            ease: "power2.inOut"
        })
        // 60%: Content trigger point using .call()
        .call(() => {
            // Content triggers directly at this point
            if (!contentTriggered) {
                contentTriggered = true;
                showContent(elements);
            }
        }, null, 0.7) // Position at 60% (0.6)
        // 60% to 80%: Content animation zone (20% of timeline)
        .to({}, { duration: 0.2 })
        // 80% to 100%: Blank space (20% of timeline)
        .to({}, { duration: 0.1 });
    });
});

// Mobile Animation (content only, no shape animation)
gsap.matchMedia().add("(max-width: 991px)", () => {
    document.querySelectorAll(".video_banner_with_text").forEach((section) => {
        const elements = getContentElements(section);
        
        // Hide all content initially
        hideAllContent(elements);
        
        let contentTriggered = false;

        // Simple scroll trigger for content animation only
        ScrollTrigger.create({
            trigger: section,
            start: "top 80%",
            end: "bottom 20%",
            markers: false,
            onEnter: () => {
                if (!contentTriggered) {
                    contentTriggered = true;
                    showContent(elements);
                }
            },
            onLeaveBack: () => {
                if (contentTriggered) {
                    contentTriggered = false;
                    hideContent(elements);
                }
            }
        });
    });
});

// Step 1: Heading + Section Animation
gsap.timeline({
    scrollTrigger: {
        trigger: ".collections-list-2-container",
        start: "top bottom-=10%",
        toggleActions: "play none none reverse",
        markers: false
    }
})
.fromTo(".collections-static-section-header", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5 })
.fromTo(".collections-list-2-container", { x: "100%", y: "100%", opacity: 0 }, { x: 0, y: 0, opacity: 1, duration: 0.8 }, "-=0.3")
.fromTo(".buttons-collection-card-wrapper", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5 });

// Remove swiper-no-swiping class on mobile
gsap.matchMedia().add("(max-width: 991px)", () => {
    const swiperContainers = document.querySelectorAll(".collections-list-2-container swiper-container");
    swiperContainers.forEach(container => {
        container.classList.remove("swiper-no-swiping");
    });
});

// Step 2: Pin section + Horizontal scroll animation (Desktop only)
gsap.matchMedia().add("(min-width: 992px)", () => {
    // const collectionsList = document.querySelector(".collections-list-2");
    // const swiperWrapper = collectionsList?.querySelector(".swiper-wrapper__custom");
    // const slides = swiperWrapper?.querySelectorAll("swiper-slide");
    // const slideCount = slides?.length || 0;
    
    // if (slideCount === 0) return;
    
    // // Calculate total scrollable width once
    // let totalWidth = 0;
    // slides.forEach((slide, index) => {
    //     totalWidth += slide.offsetWidth;
    //     if (index < slideCount - 1) {
    //         const spacing = slides[index + 1].getBoundingClientRect().left - slide.getBoundingClientRect().right;
    //         if (spacing > 0) totalWidth += spacing;
    //     }
    // });
    
    // const maxScroll = -(totalWidth - swiperWrapper.clientWidth);
    
    // gsap.timeline({
    //     scrollTrigger: {
    //         trigger: ".collections-list-2",
    //         start: "top top",
    //         end: `bottom+=${slideCount * 30}% center`,
    //         pin: true,
    //         pinSpacing: true,
    //         scrub: 1,
    //         markers: false
    //     }
    // })
    // .to(".collections-list-2 .swiper-wrapper__custom", {
    //     x: maxScroll,
    //     ease: "none",
    //     duration: 0.95
    // })
    // .to({}, { duration: 0.05 });

    // Global Auto Scroll Animation

    const imageWithTextSliderSection = document.querySelector('.image-with-text-slider-section');
    if (imageWithTextSliderSection) {
        const container = imageWithTextSliderSection.querySelector('.container, .container-fluid');
        
        // Set initial state for container - bottom to top reveal
        if (container) {
            gsap.set(container, { opacity: 0, clipPath: "inset(100% 0 0 0)" });
        }
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.image-with-text-slider-section',
                start: "top bottom",
                end: () => `bottom+=${window.innerHeight * 0.5}px center`,
                pin: true,
                pinSpacing: true,
                scrub: 1,
                ease: "power2.inOut",
                markers: false,
                onLeaveBack: () => {
                    // Pause ScrollSmoother when leaving backwards (before start point)
                    pauseScrollSmoother();
                },
                onEnter: () => {
                    document.querySelector(".testimonial-slider-section").style.pointerEvents = "none";
                },
                onLeave: () => {
                    document.querySelector(".testimonial-slider-section").style.pointerEvents = "auto";
                }
            }
            
        })
        .to('.image-with-text-slider', {
            clipPath: "inset(0% 0 0 0)",
            duration: 0.4,
            ease: "power2.inOut"
        })
        .to('.image-with-text-slider .container', {
            clipPath: "inset(0% 0 0 0)",
            duration: 0.4,
            alpha: 1,
            ease: "power2.inOut"
        },"<")
        .to('.image-with-text-slider', {
            duration: 0.5
        })
    }



    // Testimonial Slider Animation
    const testimonialSlider = document.querySelector('.testimonial-slider');
    if (testimonialSlider) {
        const contentElements = document.querySelectorAll(".swiper-wrapper-content-tm > *");
        let contentAnimated = false;

        const setTestimonialState = (isActive) => {
            document.body.style.backgroundColor = isActive ? "#1a1a1a" : "#fff";
            const testimonialSection = document.querySelector(".testimonial-slider-section");
            if (testimonialSection) {
                testimonialSection.style.pointerEvents = isActive ? "auto" : "none";
            }
        };
        
        // Set initial state for content elements
        if (contentElements.length > 0) {
            gsap.set(contentElements, { opacity: 0, y: 20 });
        }
        
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: testimonialSlider,
                start: "top top-=2px",
                end: "bottom top",
                pin: true,
                // pinSpacing: true,
                scrub: 1,
                markers: false,
                onEnter: () => {
                    setTestimonialState(true);
                },
                onLeave: () => {
                    setTestimonialState(false);
                },
                onLeaveBack: () => {
                    setTestimonialState(false);
                },
                onEnterBack: () => {
                    setTestimonialState(true);
                },
                onRefresh: (self) => {
                    setTestimonialState(self.isActive);
                },
                onUpdate: (self) => {
                    // Trigger content animation when timeline reaches approximately 0.6 progress (after container animation)
                    // 0.4 (testimonial-slider) + 0.4 (container) - 0.3 overlap = ~0.5, so at 0.6 we're past the container animation
                    if (self.progress >= 0.6 && !contentAnimated && contentElements.length > 0) {
                        contentAnimated = true;
                        gsap.to(contentElements, {
                            opacity: 1,
                            y: 0,
                            duration: 1,
                            stagger: 0.2,
                            ease: "power2.inOut"
                        });
                    }
                    // Reset flag when scrolling back
                    if (self.progress < 0.6 && contentAnimated) {
                        contentAnimated = false;
                        gsap.to(contentElements, {
                            opacity: 0,
                            y: 30,
                            duration: 0.5,
                            stagger: -0.1,
                            ease: "power2.inOut"
                        });
                    }
                }
            }
        })
        .to(".testimonial-slider", {
            clipPath: "inset(0% 0 0 0)",
            duration: 0.4,
            ease: "power2.inOut"
        })
        .to(".testimonial-slider .container", {
            clipPath: "inset(0% 0 0 0)",
            opacity: 1,
            duration: 0.4,
            ease: "power2.inOut"
        }, "-=0.3")
        .to(testimonialSlider, {
            duration: 0.3
        });
    }
});

gsap.matchMedia().add("(max-width: 991px)", () => {
    
    // Animate each media_banner_with_text individually
    const mediaBanners = document.querySelectorAll('.media_banner_with_text_index_container .media_banner_with_text');
    mediaBanners.forEach((banner) => {
        const headingBlock = banner.querySelector('.heading-block');
        const contentDivs = banner.querySelectorAll('.media_index_content > div');
        
        gsap.timeline({
            scrollTrigger: {
                trigger: banner,
                start: "top bottom-=25%",
                end: "bottom-=25% bottom-=25%",
                scrub: 1,
                ease: "power2.inOut",
                markers: false
            }
        })
        .fromTo(headingBlock, {
            transform: "translateY(30px)",
            opacity: 0,
            stagger: -0.1,
        }, {
            opacity: 1,
            transform: "translateY(0px)",
            duration: 0.5,
            stagger: 0.1,
            ease: "power2.inOut"
        })
        .fromTo(contentDivs, {
            transform: "translateY(30px)",
            opacity: 0,
            stagger: -0.1,
        }, {
            transform: "translateY(0px)",
            opacity: 1,
            duration: 0.5,
            stagger: 0.1,
            ease: "power2.inOut"
        });
    });

    gsap.timeline({
        scrollTrigger: {
            trigger: '.image-with-text-slider-section',
            start: "top bottom-=25%",
            end: "top bottom-=25%",
            scrub: 1,
            ease: "power2.inOut",
            // markers: false
        }
    })
    .fromTo('.image-with-text-slider-section .row > *', {
        clipPath: "inset(100% 0 0 0)",
        opacity: 0,
    }, {
        clipPath: "inset(0% 0 0 0)",
        opacity: 1,
        duration: 0.8,
        ease: "power2.inOut"
    });

    gsap.timeline({
        scrollTrigger: {
            trigger: '.testimonial-slider-section',
            start: "top bottom-=25%",
            end: "top+=25% bottom-=25%",
            scrub: 1,
            ease: "power2.inOut",
            markers: false,
            onEnter: () => { document.body.style.backgroundColor = '#1a1a1a'; },
            onLeaveBack: () => { document.body.style.backgroundColor = '#fff'; }
        }
    })
    .fromTo('.testimonial-slider-section .container', {
        clipPath: "inset(100% 0 0 0)",
        opacity: 0,
    }, {
        clipPath: "inset(0% 0 0 0)",
        opacity: 1,
        duration: 0.4,
        ease: "power2.inOut"
    })
    .fromTo('.swiper-wrapper-content-tm > *', {
        transform: "translateY(30px)",
        opacity: 0,
        stagger: -0.1,
    }, {
        transform: "translateY(0px)",
        opacity: 1,
        duration: 0.4,
        stagger: 0.1,
        ease: "power2.inOut"
    });
});

// Dark background transition for testimonials across breakpoints.
(function () {
    const tsEl = document.querySelector('.testimonial-slider-section');
    if (!tsEl) return;
    tsEl.style.backgroundColor = '#1a1a1a';
    ScrollTrigger.create({
        trigger: tsEl,
        start: 'top bottom',
        onEnter: () => { document.body.style.backgroundColor = '#1a1a1a'; },
        onLeaveBack: () => { document.body.style.backgroundColor = '#fff'; }
    });
})();

// Resume ScrollSmoother when user scrolls after it's paused
let scrollTimeout;
const handleScroll = () => {
    // Only call resume if ScrollSmoother is ready
    if (typeof ScrollSmoother !== 'undefined') {
        try {
            const smoother = ScrollSmoother.get();
            if (smoother && typeof smoother.paused === 'function') {
                resumeScrollSmoother();
            }
        } catch (e) {
            // ScrollSmoother might not be fully initialized yet, ignore
        }
    }
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
        // Small delay to ensure smooth operation
    }, 100);
};
window.addEventListener('scroll', handleScroll, { passive: true });
window.addEventListener('wheel', handleScroll, { passive: true });


/*=============================================
=           collection GSAP Animation         =
=============================================*/

// Custom Section Animation (Slide Bottom to Top) - Only for collection-animate class
document.querySelectorAll(".custom-section.collection-animate").forEach((section) => {
    const imageBlock = section.querySelector(".group-block .image-block");
    const groupBlocks = section.querySelectorAll(".group-block");
    const imageTarget = imageBlock || section;
    const imageDuration = 1.5;
    const contentSelectors = [".heading-block", ".text-block", "a.btn, a.btn-link"];
    
    // Set initial states
    gsap.set(imageTarget, { clipPath: "inset(100% 0 0 0)" });
    groupBlocks.forEach((groupBlock) => {
        contentSelectors.forEach(selector => {
            const element = groupBlock.querySelector(selector);
            if (element) gsap.set(element, { opacity: 0, y: 30 });
        });
    });
    
    // Create timeline
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: "top bottom-=15%",
            end: "top bottom-=15%",
            toggleActions: "play none none reverse"
        }
    });
    
    // Animate image
    tl.to(imageTarget, {
        clipPath: "inset(0% 0 0 0)",
        duration: imageDuration,
        ease: "power2.inOut"
    });
    
    // Animate content blocks sequentially starting at 50% of image animation
    const startTime = imageDuration * 0.5;
    groupBlocks.forEach((groupBlock) => {
        contentSelectors.forEach((selector, index) => {
            const element = groupBlock.querySelector(selector);
            if (element) {
                tl.to(element, {
                    opacity: 1,
                    y: 0,
                    duration: 0.7,
                    ease: "power2.out"
                }, startTime + (index * 0.2));
            }
        });
    });
});
